<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <button @click.prevent="invoice_close" class="btn btn-outline-primary">&lt; Return to list</button>
            <h3 class="mb-0 ms-4">Invoice {{ invoiceId }}</h3>
        </div>
        <div class="card border-0 mx-0 px-0">
            <div class="card-body">
                <div class="row">
                    <form 
                        class="col-xs-12 col-sm-6 col-lg-4 mt-2" 
                        autocomplete=off 
                        @submit.stop.prevent
                    >
                        <div class="mb-3">
                            <label class="form-label">Invoice number</label>
                            <input  
                                class="form-control"
                                v-model="invoice_number"
                                readonly
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Invoice date</label>                
                            <input  
                                class="form-control"
                                v-model="invoice_date"
                                readonly
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Invoice due date</label>
                            <input  
                                class="form-control"
                                v-model="invoice_due_date"
                                readonly
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Invoice reference</label>
                            <input  
                                class="form-control"
                                v-model="invoice_reference"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_reference',invoice_reference)" 
                            />
                        </div>                    
                        <div class="mb-3">
                            <label class="form-label">Invoice address</label>
                            <input  
                                class="form-control"
                                v-model="invoice_name"
                                placeholder="Invoice name"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_name',invoice_name)" 
                            />
                            <input  
                                class="form-control mt-2"
                                v-model="invoice_company"
                                placeholder="Invoice company"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_company',invoice_company)" 
                            />   
                            <input  
                                class="form-control mt-2"
                                v-model="invoice_address_1"
                                placeholder="Invoice address 1"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_address_1',invoice_address_1)" 
                            />
                            <input  
                                class="form-control mt-2"
                                v-model="invoice_address_2"
                                placeholder="Invoice address 2"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_address_2',invoice_address_2)" 
                            />
                            <input  
                                class="form-control mt-2"
                                v-model="invoice_zip_code"
                                placeholder="Invoice zip code"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_zip_code',invoice_zip_code)" 
                            />
                            <input  
                                class="form-control mt-2"
                                v-model="invoice_city"
                                placeholder="Invoice city"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_city',invoice_city)" 
                            />                                                                                                 
                        </div>
                    </form>
                    <form 
                        class="col-xs-12 col-sm-6 col-lg-4 mt-2" 
                        autocomplete=off 
                        @submit.stop.prevent
                    >            
                        <div class="mb-3">
                            <label class="form-label">Invoice amount</label>
                            <input  
                                class="form-control"
                                v-model="invoice_amount"
                                readonly
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">VAT amount</label>
                            <input  
                                class="form-control"
                                v-model="invoice_vat_amount"
                                readonly
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Invoice status</label>
                            <select  
                                class="form-select"
                                v-model="invoice_status"
                                disabled
                            >
                                <option v-for="status in invoicestatuses" :key="status.value" :value="status.value">
                                    {{ status.text }}
                                </option>
                            </select>
                        </div>                    
                        <div class="mb-3">
                            <label class="form-label">Paid amount</label>
                            <input  
                                class="form-control"
                                v-model="invoice_paid_amount"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_paid_amount',invoice_paid_amount)" 
                            />
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Payment method</label>
                            <select  
                                class="form-select"
                                v-model="invoice_payment_method_id"
                                disabled
                            >
                                <option v-for="method in paymentmethods" :key="method.value" :value="method.value">
                                    {{ method.text }}
                                </option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Payment transaction id</label>
                            <input  
                                class="form-control"
                                v-model="invoice_payment_reference"
                                @change="savefield('g_consultantinvoices',invoiceId,'invoice_payment_reference',invoice_payment_reference)" 
                            />
                        </div>                                                         
                    </form> 
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'Invoice',
    props: [
        'invoiceId',
    ],
    data: function() {
        return {
            invoice_number: '',
            invoice_date: '',
            invoice_due_date: '',
            invoice_reference: '',
            invoice_amount: 0,
            invoice_vat_amount: 0,
            invoice_paid_amount: 0,
            invoice_status: 0,
            invoice_payment_method_id: 0,
            invoice_payment_reference: '',
            invoice_text: '',
            invoice_type: '',
            invoice_record_id: '',
            invoice_name: '',
            invoice_company: '',
            invoice_address_1: '',
            invoice_address_2: '',
            invoice_zip_code: '',
            invoice_city: '',
            paymentmethods: [],
            invoicestatuses: [
                { value: 0, text: 'No status'},
                { value: 1, text: 'Created' },
                { value: 2, text: 'Processed' },
            ],
            survey_name: '',
            surver_number_members: 0,
        }
    },
    mounted() {
        this.paymentmethods_get();
    },
    watch: {
        invoiceId() {
            this.invoice_get();
        }
    },
    methods: {
        savefield(tablename,id,fieldname,value) {
            if (fieldname.indexOf('_date') != -1) {
                value = this.format_date(value);
            }
            if ( id > 0 ) { 
                var record = {
                    id: id,
                    [fieldname]: value,
                }
                this.$store.dispatch('field_save', { tablename: tablename,record: record })
                .then(() => {
                    this.invoice_changed();
                });
            }
        },        
        paymentmethods_get() {
            this.$store.dispatch("records_readall", { table_name: 'g_paymentmethods' })
            .then((resp) => {
                var p = resp.data.result.map( (r) => {
                    return {
                        value: r.id,
                        text: r.paymentmethod_name,
                    }
                });
                this.paymentmethods = p;
            });
        },
        invoice_get() {
            if (this.invoiceId != 0) {
                this.$store.dispatch("record_read", { table_name: 'g_consultantinvoices', id: this.invoiceId })
                .then((resp) => {
                    const invoice = resp.data;
                    this.invoice_number = invoice.invoice_number;
                    this.invoice_date = invoice.invoice_date;
                    this.invoice_due_date = invoice.invoice_due_date;
                    this.invoice_reference = invoice.invoice_reference;
                    this.invoice_amount = invoice.invoice_amount;
                    this.invoice_vat_amount = invoice.invoice_vat_amount;
                    this.invoice_paid_amount = invoice.invoice_paid_amount;
                    this.invoice_status = invoice.invoice_status;
                    this.invoice_payment_method_id = invoice.invoice_payment_method_id;
                    this.invoice_payment_reference = invoice.invoice_payment_reference;
                    this.invoice_text = invoice.invoice_text;
                    this.invoice_type = invoice.invoice_type;
                    this.invoice_record_id = invoice.invoice_record_id;
                    this.invoice_name = invoice.invoice_name;
                    this.invoice_company = invoice.invoice_company;
                    this.invoice_address_1 = invoice.invoice_address_1;
                    this.invoice_address_2 = invoice.invoice_address_2;
                    this.invoice_zip_code = invoice.invoice_zip_code;
                    this.invoice_city = invoice.invoice_city;
                    this.survey_get(invoice.invoice_record_id);
                })
            }
        },
        survey_get(survey_id) {
            if (survey_id != 0) {
                this.$store.dispatch("record_read", { table_name: 'g_surveys', id: survey_id })
                .then((resp) => {
                    const survey = resp.data;
                    this.survey_name = survey.survey_name;
                })
            }
        },
        invoice_close() {
            this.$emit("invoiceClose");  
        },
        invoice_changed() {
            this.$emit("invoiceChange");
        }
    }   
    
}


</script>
<style scoped>

</style>
